import { renderBreadcrumbItem_unstable } from '@fluentui/react-breadcrumb';

/**
 * Renders the final JSX of the BreadcrumbItem component, given the state.
 */
export const renderBreadcrumbItem = renderBreadcrumbItem_unstable;
